import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';


//import classNames from 'classnames';
import {grey} from '@mui/material/colors';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import { Box } from '@mui/material';

const s:any = {
  navigation: {
    fontSize: 15,
    fontWeight: 300,
    color: grey['600'],
    paddingBottom: 15,
    display: 'block'
  },
  title: {
    fontSize: 24,
    fontWeight: 300,
    marginBottom: 20,
    color:'white'
  },
  paper: {
    //padding: 5,
    //height: '88vh',
    // marginBottom: 20,
  },
  minipaper: {
    marginTop: 30,
    margin: 'auto',
    padding: 0,
    width: '60%'
  },
  clear: {
    clear: 'both'
  }
};

class PageBase extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      count:0
    };
  }

  // componentWillReceiveProps(nextProps) {
  //   if (this.props.page !== nextProps.page) {
  //       this.setState({page: nextProps.page});
  //   }
  // }

  render() {
    const {nav, navigation, title, mini, children,classes} = this.props;

    return (
      <Fragment>
        {nav && <Box component='span' sx={{...s.navigation}}>{navigation}</Box> }

        <Paper sx={{...(mini?s.minipaper:s.paper)}}>
          {title?
            <Box><Box component='h3' sx={{...s.title}}>{title}</Box><Divider/></Box>
          : undefined
          }
          
          {children}

          <Box sx={{...s.clear}}/>

        </Paper>
      </Fragment>
    );
  }
}

PageBase.propTypes = {
  title: PropTypes.string,
  navigation: PropTypes.string,
  children: PropTypes.element
};

export default PageBase;
